import "../style/introduce.css"
const Introduce=()=>{
	return(
		<div className="Introduce">
			<div className="Introduce_title">
				<h1>飯店介紹</h1>
			</div>
			<div className="Introduce_wrap">

				<div className="Introduce_img">
					{/*
					<img src="/imgs/introduce.jpg" alt="introduce.jpg"/>
					*/}
				
				</div>

				<div className="Introduce_content">
					<p>
						聖亞哥商務旅館位於四季如春、
						陽光和熙的高雄港都，地處高雄市中心鄰近六合夜市，
						交通極為便利，無論是到高雄港、西子灣、旗津、統一夢時代、
						瑞豐夜市等風景勝地，都可暢遊無阻。 樸實的外表下，
						有著別於一般旅館的內涵，讓旅遊、出差洽商或想片刻休憩的您，
						有著寧靜舒適的空間。聖亞哥旅館免除了您舟車奔波之苦，
						也是您計劃中休息觀光絕佳的好住處。 
					</p>

					<p>
						聖亞哥旅館座落於高雄市中心六合路、明星街，
						到高雄火車站、客運站只要五分鐘，至小港機場僅需十五分鐘，
						地點適中、交通方便、緊鄰聞名全台的六合觀光夜市，各式風味小吃、
						應有盡有。
					</p>
				</div>
			</div>
			
		</div>

		)
}
export default Introduce;
